import { render, staticRenderFns } from "./list_biaogan.vue?vue&type=template&id=2ba7f0d3&scoped=true&"
import script from "./list_biaogan.vue?vue&type=script&lang=js&"
export * from "./list_biaogan.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&"
import style1 from "./list_biaogan.vue?vue&type=style&index=1&id=2ba7f0d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba7f0d3",
  null
  
)

export default component.exports